export const parameters = [
    'width',
    'componentSize',
    'composition',
    'zipperType',
    'grammage',
    'producerCode',
    'underSliderType',
    'upperSliderType',
    'yardage',
];
function getLabel(i18n, labelsDict, attrType, categoryCode) {
    // category specific
    let attrInfo = labelsDict === null || labelsDict === void 0 ? void 0 : labelsDict.find((attr) => attr.attributeType === attrType && attr.category === categoryCode);
    // general
    if (!attrInfo) {
        attrInfo = labelsDict === null || labelsDict === void 0 ? void 0 : labelsDict.find((attr) => attr.attributeType === attrType);
    }
    if (attrInfo) {
        return (i18n.language === 'en' ? attrInfo.attributeLabelEN : attrInfo.attributeLabelPL) || '-';
    }
    return '-';
}
export function getAttributeLabel(i18n, productLabels, attrType, categoryCode) {
    var _a;
    return getLabel(i18n, (_a = productLabels === null || productLabels === void 0 ? void 0 : productLabels.autocomplete) === null || _a === void 0 ? void 0 : _a.productLabels, attrType, categoryCode);
}
export function getAttributeVariantLabel(i18n, labelsDictionary, attrType, categoryCode) {
    var _a;
    return getLabel(i18n, (_a = labelsDictionary === null || labelsDictionary === void 0 ? void 0 : labelsDictionary.autocomplete) === null || _a === void 0 ? void 0 : _a.productVariantLabels, attrType, categoryCode);
}
export const parameterToCategory = {
    width: 'hasWidth',
    componentSize: 'hasComponentSize',
    composition: 'hasComposition',
    zipperType: 'hasZipperType',
    upperSliderType: 'hasUpperSliderType',
    underSliderType: 'hasUnderSliderType',
    grammage: 'hasGrammage',
    producerCode: 'hasProducerCode',
    yardage: 'hasYardage',
};
export const categoryToParameter = {
    hasWidth: 'width',
    hasComponentSize: 'componentSize',
    hasComposition: 'composition',
    hasZipperType: 'zipperType',
    hasUpperSliderType: 'upperSliderType',
    hasUnderSliderType: 'underSliderType',
    hasGrammage: 'grammage',
    hasProducerCode: 'producerCode',
    hasYardage: 'yardage',
};
